import { render, staticRenderFns } from "./Today.vue?vue&type=template&id=5519d72b&scoped=true&"
import script from "./Today.vue?vue&type=script&lang=js&"
export * from "./Today.vue?vue&type=script&lang=js&"
import style0 from "./Today.vue?vue&type=style&index=0&id=5519d72b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5519d72b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\carli\\Documents\\Github\\Sharo Employee New\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5519d72b')) {
      api.createRecord('5519d72b', component.options)
    } else {
      api.reload('5519d72b', component.options)
    }
    module.hot.accept("./Today.vue?vue&type=template&id=5519d72b&scoped=true&", function () {
      api.rerender('5519d72b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Home/Today.vue"
export default component.exports